import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createBilling({ commit }, data) {
      try {
        return await api.post('/billings', data)
      } catch (error) {
        throw error
      }
    },

    async getBillings({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/billings?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getBillingClient({ commit }, faturamentoClienteId) {
      try {
        const response = await api.get(`/billings/${faturamentoClienteId}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateBillingClient({ commit }, data) {
      try {
        return await api.put(`/billings/${data.id}`, data)
      } catch (error) {
        throw error
      }
    },

    async checkedBillingClient({ commit }, data) {
      try {
        return await api.post('/billings/checked', data)
      } catch (error) {
        throw error
      }
    },

    async integrateAliquotWithRM({ commit }, data) {
      try {
        return await api.post('/billings/integrate-aliquot', data)
      } catch (error) {
        throw error
      }
    },

    async integrateBillingWithRM({ commit }, data) {
      try {
        return await api.post('/billings/integrate-billing', data)
      } catch (error) {
        throw error
      }
    },

    async deleteBillingClient({ commit }, faturamentoClienteId) {
      try {
        return await api.delete(`/billings/${faturamentoClienteId}`)
      } catch (error) {
        throw error
      }
    },

    async authorizationNFBillingClient({ commit }, faturamentoClienteId) {
      try {
        return await api.get(
          `/billings/${faturamentoClienteId}/authorization-nf`,
        )
      } catch (error) {
        throw error
      }
    },

    async getNFBillingClient({ commit }, { faturamentoClienteId, signal }) {
      try {
        const response = await api.get(
          `/billings/${faturamentoClienteId}/download-nf`,
          { signal },
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
